import { getPopularSearches as algoliaGetPopularSearches } from './providers/algolia/getPopularSearches';
import { getPopularSearches as elasticGetPopularSearches } from './providers/elastic/getPopularSearches';

export const getPopularSearches = async (): Promise<Array<string>> => {
  if (process.env.GATSBY_ELASTICSEARCH_ENGINE) {
    return elasticGetPopularSearches();
  }

  if (process.env.GATSBY_ALGOLIA_INDEX) {
    return algoliaGetPopularSearches();
  }

  return [];
};
